//@ts-expect-error
import Cookies from "js-cookie";
import {jwtDecode} from 'jwt-decode';
import {COOKIE_NAME, USER_ROLES} from "../../consts/user";
import {type InitialState, type Actions, ACTION_TYPES} from "./types";
import {ACTION_TYPES as ORGANISATION_ACTIONTYPES} from "../organisation/types";
import {IOrganisation} from "../../common/organisation";

type TokenValue = {
    username?: string;
    role?: USER_ROLES[];
    exp?: number;
    name?: string;
    sub?: string;
};

const savedToken: TokenValue = Cookies.get(COOKIE_NAME)
    ? jwtDecode(Cookies.get(COOKIE_NAME)) 
    : {};

const initialState: InitialState = {
    role: savedToken.role || [],
    name: savedToken.username,
    organisation: {} as IOrganisation, 
}

const userStore = (state:InitialState = initialState, {type, payload}: Actions) => {
    switch(type) {
        case ACTION_TYPES.LOGIN_SUCCESS: { 
            const {name, role, username, sub} = jwtDecode(String(payload)) as TokenValue;
            return {
                ...state,
                name,
                role,
                username,
                sub,
            }
        }
        case ORGANISATION_ACTIONTYPES.GET_MY_ORGANISATION_SUCCESS: {
            return {
                ...state,
                //@ts-expect-error
                organisation: payload.alias,
            }
        }
        default: 
            return state;
    }
}

export default userStore;